const ExpenditureActionTypes = {
  SET_PAYMENTS: 'SET_PAYMENTS',
  REMOVE_PAYMENT: 'REMOVE_PAYMENT',
  SET_REVERSED_PAYMENTS: 'SET_REVERSED_PAYMENTS',
};

export default ExpenditureActionTypes;
